import {Location} from '@/model/api';
import {SearchResult} from '@/model/api/search';
import LocationFinder from '@/model/LocationFinder';

const RUIAN_URL = '/api/ruian-locations';
const OSM_URL = '/api/osm-locations';

export default class ApiLocationFinder implements LocationFinder {
    constructor(
        private readonly endpoint: string,
        private readonly additionalQueryParameters: { [parameterName: string]: string } = {},
    ) {
    }

    public search(searchQuery: string): Promise<SearchResult<Location>> {
        const queryParameters = new URLSearchParams({
            ...this.additionalQueryParameters,
            query: searchQuery,
        });

        return fetch(`${this.endpoint}?${queryParameters.toString()}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Location search failed with status ${response.status}`);
                }
                return response.json();
            })
            .then(body => ({groups: body.result}));
    }

    public static openStreetMap(): ApiLocationFinder {
        return new ApiLocationFinder(OSM_URL);
    }

    /**
     * @param locationTypes Location types to search in or empty array to search in all location types
     */
    public static ruian(locationTypes: string[] = []): ApiLocationFinder {
        return new ApiLocationFinder(
            RUIAN_URL,
            locationTypes.length > 0 ? { locationTypes: locationTypes.join(',') } : {},
        );
    }
}
